<template>
  <div class="spot-list-only">
    <div class="spot-table-wrap" v-loading="loading">
      <div class="spot-table-inner">
        <v-table
          density="compact"
          fixed-header
          height="360"
          class="bg-transparent flex-grow-1 gm-table ops-table ops-spot-table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th class="spot-col-time" style="width: 88px">时刻</th>
              <th class="text-end" style="min-width: 132px">市场电价(元/兆瓦时)</th>
              <th class="text-end" style="min-width: 132px">服务费(元/兆瓦时)</th>
              <th class="text-end" style="min-width: 140px">最终执行价(元/兆瓦时)</th>
              <th class="text-center" style="width: 110px">数据来源</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in viewRows" :key="String(row.timeSlot) + '-' + idx">
              <td class="spot-col-time">{{ row.timeSlot }}</td>
              <td class="text-end">
                <span class="cell-text">{{ formatNumber(row.marketPrice) }}</span>
              </td>
              <td class="text-end">
                <span class="cell-text">{{ formatNumber(row.servicePrice) }}</span>
              </td>
              <td class="text-end">
                <span class="cell-text">{{ formatNumber(row.finalPrice) }}</span>
              </td>
              <td class="text-center">
                <span class="cell-text cell-text--center">{{ row.sourceType === 2 ? '人工调整' : '市场接口' }}</span>
              </td>
            </tr>
            <tr v-if="viewRows.length === 0 && !loading">
              <td class="empty-cell" colspan="5">暂无数据（请调整筛选条件）</td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { getSpotPriceData } from '@/api/business-operations'

defineOptions({ name: 'SpotPriceListOnly' })

const props = defineProps({
  areaCode: { type: [String, Number], default: '' },
  priceDate: { type: String, default: '' }, // YYYY-MM-DD
  auto: { type: Boolean, default: true },
})

const loading = ref(false)
const rows = ref([])

const formatNumber = (v) => {
  const n = Number(v)
  if (!Number.isFinite(n)) return '-'
  return n.toFixed(6)
}

const viewRows = computed(() => rows.value || [])

const fetchRows = async () => {
  if (!props.areaCode || !props.priceDate) {
    rows.value = []
    return
  }
  loading.value = true
  try {
    const res = await getSpotPriceData({
      areaCode: props.areaCode || undefined,
      priceDate: props.priceDate,
    })
    const list = Array.isArray(res?.data) ? res.data : []
    rows.value = list.map((it) => {
      const mp = it?.marketPrice ?? 0
      const sp = it?.servicePrice ?? 0
      const fp = it?.finalPrice
      const hasFp = fp !== null && fp !== undefined && fp !== ''
      const finalPrice = hasFp ? fp : (Number(mp || 0) + Number(sp || 0)).toFixed(6)
      return {
        id: it?.id,
        timeSlot: it?.timeSlot,
        marketPrice: mp,
        servicePrice: sp,
        finalPrice,
        sourceType: it?.sourceType ?? 1,
      }
    })
  } finally {
    loading.value = false
  }
}

defineExpose({ refresh: fetchRows })

watch(
  () => [props.areaCode, props.priceDate],
  () => {
    if (props.auto) fetchRows()
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.spot-list-only {
  width: 100%;
}

.spot-table-wrap {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.78);
  min-height: 420px;
  display: flex;
}

.spot-table-inner {
  width: 100%;
  min-width: 0;
}

.cell-text {
  color: rgba(46, 46, 46, 0.86);
}

.cell-text--center {
  display: inline-block;
  min-width: 4em;
}

.empty-cell {
  text-align: center;
  color: rgba(46, 46, 46, 0.5);
  padding: 18px 0;
}
</style>

